import React from "react";

import { indexAct } from "../api/indexAct";

import device from "../../functions/device";

import { Carousel, Card, Modal, message, Spin } from "antd";

import "antd/es/carousel/style/css";
import "antd/es/card/style/css";

export default class News extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      modal: false,
      activeNewsIndex: -1,
      news: [],
    };
  }

  componentDidMount() {
    this.getNews();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.lang !== prevProps.lang) {
      this.getNews();
    }
  }

  getNews = () => {
    indexAct("GET_NEWS", {}, "/").then((data) => {
      if (data.code === 200) {
        this.setState((state) => {
          state.loading = false;
          state.news = data.res;
          return state;
        });
      } else {
        message.error("შეცდომა!", 5);
      }
    });
  };

  render() {
    const { loading, news, modal, activeNewsIndex } = this.state;
    return (
      <>
        <div className="ant-segment" id="news">
          <div className="page-title-ribbon ribbon-color-1">
            <span className="page-title-ribbon-content">
              {" "}
              {
                this.props.info.ROUTES.find((el) => el.COMPONENT === "News")
                  .PAGE_NAME
              }
            </span>
          </div>
          <div className="page-content">
            {loading ? (
              <Spin
                style={{
                  width: "100%",
                  height: "100%",
                }}
              />
            ) : (
              <Carousel
                slidesToShow={3}
                autoplay={true}
                pauseOnHover
                dots={false}
                draggable
                responsive={[
                  {
                    breakpoint: 600,
                    settings: {
                      slidesToShow: 1,
                    },
                  },
                ]}
              >
                {news.map((el, i) => {
                  return (
                    <div
                      key={i}
                      className="news-card"
                      onClick={() => {
                        this.setState({
                          activeNewsIndex: i,
                          modal: true,
                        });
                      }}
                    >
                      <Card
                        size="small"
                        cover={
                          <img
                            //style={{ height: "400px" }}
                            alt="example"
                            src={
                              "https://source.unsplash.com/800x400/?medical,equipment?v" +
                              i
                            }
                          />
                        }
                      >
                        <Card.Meta
                          title={el.NEWS_NAME}
                          description={el.NEWS_DESCRIPTION}
                        />
                      </Card>
                    </div>
                  );
                })}
              </Carousel>
            )}
          </div>
        </div>
        <Modal
          destroyOnClose
          title={activeNewsIndex >= 0 ? news[activeNewsIndex].NEWS_NAME : ""}
          width={device().isMobile ? "100%" : "70%"}
          visible={modal}
          onCancel={() => {
            this.setState({
              modal: false,
              activeNewsIndex: -1,
            });
          }}
          footer={null}
          centered
          bodyStyle={{
            height: "500px",
            overflowY: "auto",
            padding: "15px 15px",
          }}
        >
          {activeNewsIndex >= 0 ? news[activeNewsIndex].NEWS_DESCRIPTION : ""}
        </Modal>
      </>
    );
  }
}
